// XGO Maps Project - Unified Configuration
// All configuration settings in one place to reduce confusion

//------- PRODUCTION LIVE
export const API_URL = 'https://srv547457.hstgr.cloud:4002';
export const XGO_TEXT_SMS_URL = 'https://srv547457.hstgr.cloud:3003';
export const MAPS_BACKEND_URL = 'https://srv547457.hstgr.cloud:4002';

// //------- PRODUCTION TEST 
// export const API_URL = 'https://srv547457.hstgr.cloud:3011';
// export const XGO_TEXT_SMS_URL = 'https://srv547457.hstgr.cloud:3003';
// export const MAPS_BACKEND_URL = 'https://srv547457.hstgr.cloud:3011';

//---------TEST LOCAL
// export const API_URL = "http://10.120.228.32:4002";
// export const XGO_TEXT_SMS_URL = 'https://srv547457.hstgr.cloud:3003';
// export const MAPS_BACKEND_URL = "http://10.120.228.32:4002";

// Maps Backend Configuration
export const MAPS_CONFIG = {
  // Backend server URL
  BASE_URL: MAPS_BACKEND_URL,
  
  // Maps proxy endpoints
  ENDPOINTS: {
    GEOCODE: '/api/maps/geocode',
    DIRECTIONS: '/api/maps/directions', 
    STATIC: '/api/maps/static',
    USAGE: '/api/maps/usage'
  },
  
  // Security settings
  GOOGLE_MAPS_API_KEY: 'AIzaSyDZG_3GglukjKo0k6rd9ckpoxX6XCOElVo', // Replace with actual key
  
  // Development settings
  USE_DIRECT_API: false, // Always use backend proxy for security
  
  // Performance settings
  BATCH_REQUESTS: true,
  CACHE_ENABLED: true,
  CACHE_TTL: 300000, // 5 minutes
  REQUEST_TIMEOUT: 10000, // 10 seconds
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000 // 1 second
};

// API Keys Configuration (centralized)
export const API_KEYS = {
  googleMaps: MAPS_CONFIG.GOOGLE_MAPS_API_KEY,
  // Add other API keys as needed
};

// Export function for backward compatibility
export const getGoogleMapsApiKey = () => {
  return MAPS_CONFIG.GOOGLE_MAPS_API_KEY;
};

// Application Configuration
export const APP_CONFIG = {
  // App metadata
  APP_NAME: 'XGO Maps',
  VERSION: '1.0.0',
  
  // Map settings
  DEFAULT_ZOOM: 15,
  DEFAULT_LOCATION: {
    lat: -17.8292,
    lng: 31.0539 // Harare, Zimbabwe
  },
  
  // UI settings
  MAP_STYLE: 'roadmap', // roadmap, satellite, hybrid, terrain
  CONTROLS_ENABLED: true,
  
  // Feature flags
  ENABLE_ANALYTICS: false, // Set to true for production
  ENABLE_DEBUG_MODE: true, // Set to false for production
  ENABLE_OFFLINE_MODE: false
};

// Secure API Functions for Maps
export const secureGeocode = async (lat, lng) => {
  try {
    const response = await fetch(
      `${MAPS_CONFIG.BASE_URL}${MAPS_CONFIG.ENDPOINTS.GEOCODE}?lat=${lat}&lng=${lng}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: MAPS_CONFIG.REQUEST_TIMEOUT
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Secure geocoding failed:', error);
    throw error;
  }
};

export const secureDirections = async (origin, destination) => {
  try {
    const response = await fetch(
      `${MAPS_CONFIG.BASE_URL}${MAPS_CONFIG.ENDPOINTS.DIRECTIONS}?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: MAPS_CONFIG.REQUEST_TIMEOUT
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Secure directions failed:', error);
    throw error;
  }
};

export const checkUsage = async () => {
  try {
    const response = await fetch(
      `${MAPS_CONFIG.BASE_URL}${MAPS_CONFIG.ENDPOINTS.USAGE}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Usage check failed:', error);
    return null;
  }
};

// Utility Functions
export const getCurrentEnvironment = () => process.env.NODE_ENV || 'development';
export const isProduction = () => process.env.NODE_ENV === 'production';
export const isDevelopment = () => process.env.NODE_ENV === 'development';

// Legacy exports for backward compatibility
export const BACKEND_CONFIG = MAPS_CONFIG;

// Export all configurations as a single object for easy import
export const CONFIG = {
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  API_CONFIG: MAPS_CONFIG,
  MAPS_CONFIG,
  APP_CONFIG,
  secureGeocode,
  secureDirections,
  checkUsage
};

console.log(`🚀 XGO Maps Configuration Loaded - Environment: ${process.env.NODE_ENV || 'development'}`);
console.log(`📍 API URL: ${API_URL}`);
console.log(`🗺️  Maps Backend: ${MAPS_CONFIG.BASE_URL}`);
